import SearchIcon from '../assets/icon_search.svg'
import {Row} from "./Row";
import Chevron from '../assets/chevron.svg'
import {useEffect, useRef, useState} from 'react';
import moment from "moment";
import {useInViewport} from 'react-in-viewport';
import {clearSearchTable, searchTable} from "../context/actions/userActions";
import {useAPIData} from "../context/hooks/useAPIData";
import {Countdown} from "./Countdown";

export const TableTop = (props) => {
    const data = useAPIData()
    const {raceRef, isFutureRace} = props
    const tableRef = useRef(null)
    const {totalAmountLeft, totalPlayers, totalPrizes, start, end, players, id} = props.data
    const [extended, setExtended] = useState(!props.inactive)
    const [name, setName] = useState('')
    const [playerList, setPlayers] = useState(players)
    const index = !props.inactive ? data.activeRaces.map(race => race.id).indexOf(id) : data.oldRaces.map(race => race.id).indexOf(id)
    const searched = data && (!props.inactive ? (data.activeRaces && data.activeRaces[index] && data.activeRaces[index].searched) : (data.oldRaces && data.oldRaces[index] && data.oldRaces[index].searched))
    const {
        inViewport
    } = useInViewport(
        raceRef,
        {},
        {disconnectOnLeave: false},
        props
    );

    useEffect(() => {
        setName('')
        setPlayers(players)
    }, [players])

    useEffect(() => {
        setName('')
        return () => {
            setName('')
            clearSearch()
        }
    }, [])

    useEffect(() => {
        if (!searched || searched.length < 1) {
            name.length > 0 && data.openPopup()
            return
        }
        setPlayers(searched)
    }, [searched])

    const onSubmit = (e) => {
        e.preventDefault()
        searchTable(data.dispatch, id, name, !props.inactive)
    }

    const onChange = (e) => {
        setName(e.target.value)
    }

    const clearSearch = () => {
        setName('')
        setPlayers(players)
        clearSearchTable(data.dispatch, id)
    }

    return (
        <div className={"card " + (isFutureRace ? 'card-future ' : '') + (props.inactive ? 'card-inactive ' : '') + (props.visible ? 'showTerms' : '')}>
            <h2 className="desktop-title">Clasament</h2>
            <div className="card-section card-header">
                <div className="card-header-infos">
                    <div className="info">
                        <span>{'Total premii'}</span>
                        <div className="withCurrency"><span
                            className="totalAmountLeft">{totalAmountLeft.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' '}</span>
                            <span>{!isFutureRace ? 'lei' : ''}</span>
                        </div>
                    </div>
                    <div className="info">
                        <span>{isFutureRace ? 'Începe în' : 'Timp rămas'}</span>
                        <div className="time">{moment(end).isBefore(moment()) ? <span>ÎNCHEIATĂ</span> :
                            <Countdown endDate={isFutureRace ? start : end}/>}</div>
                    </div>
                    <div className="info">
                        <span>{isFutureRace ? 'Locuri plătite' : 'Participanți'}</span>
                        <div className="totalPlayers"><span>{(isFutureRace ? totalPrizes : totalPlayers) + ' '}</span> <span>jucători</span></div>
                    </div>
                </div>
            </div>
            {!isFutureRace && <div className="card-section card-searchbar">
                <form onSubmit={onSubmit}>
                    <img className="search-icon" src={SearchIcon} alt="search"/>
                    <input onChange={onChange} placeholder="Introdu email/username" value={name} autoComplete="off"
                           type="text" name="search"/>
                    <div className={"input-clear " + (name.length > 0 ? 'showTerms' : '')}
                         onClick={clearSearch}>&times;</div>
                    <button type="submit">Caută</button>
                </form>
            </div>}
            {!isFutureRace && <div ref={tableRef} className={"card-section card-table " + (extended ? '' : 'card-table-inactive')}>
                <div className="card-row card-table-header">
                    <div className="card-data card-data-title">Loc</div>
                    <div className="card-data card-data-title">User</div>
                    <div className="card-data card-data-title">Scor</div>
                    <div className="card-data card-data-title">Premiu</div>
                    <div className="card-data card-data-title">Evoluție</div>
                </div>

                {inViewport && playerList && playerList.map((player, index) => <Row type={'Clasament'} key={index}
                                                                                    data={player}/>)}
            </div>}
            {!isFutureRace && <div className="dropdown-inactive-card">
                {playerList && playerList.length > 3 && props.inactive && <div className="dropdown-inactive-card-wrapper" onClick={() => {
                    setExtended(!extended)
                    tableRef.current.scrollTo({
                        top: 0
                    })
                }}>
                    <p>{extended ? 'Ascunde întreaga listă de câștigători' : 'Vezi întreaga listă de câștigători'}</p>
                    <img src={Chevron} style={extended ? {transform: 'rotate(180deg)'} : {}} alt={''}/></div>}
            </div>}
        </div>
    )
}